import {
  SET_LOADING,
  GET_PAYMENTS,
  GET_PAYMENTS_ERROR,
  GET_UNMATCHED,
  GET_PAYMENT,
  GET_PAYMENT_ERROR,
  GET_DETAILS,
  GET_DETAILS_ERROR,
  EDIT_CUSTOMER_INFO,
  PAYMENT_ORDER_POSTING,
  PAYMENT_ACTION_ERROR,
} from "../../types";

const PaymentReducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_PAYMENTS:
      return {
        ...state,
        payments: action.payload.payments,
        loading: false,
      };

    case GET_PAYMENTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PAYMENT:
      return {
        ...state,
        payment: action.payload.payments,
        loading: false,
      };

    case GET_PAYMENT_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case GET_DETAILS:
      return {
        ...state,
        details: action.payload.details,
        loading: false,
      };

    case GET_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case GET_UNMATCHED:
      const checked = action.payload;
      const payments_unmatched = [];
      if (checked === true) {
        for (let x in state.payments) {
          if (state.payments[x].shopify === "Unmatched") {
            payments_unmatched.push(state.payments[x]);
          }
        }
      }
      return {
        ...state,
        payments_unmatched: payments_unmatched,
      };

    case EDIT_CUSTOMER_INFO:
      return {
        ...state,
        returned_info: action.payload.returned_info,
        loading: false,
      };

    case PAYMENT_ORDER_POSTING:
      return {
        ...state,
        returned_posting: action.payload,
        loading: false,
      };

    case PAYMENT_ACTION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default PaymentReducer;